import React from 'react';

import ReactDOM from 'react-dom';

import {Input, Button,Dropdown} from "@jd/find-react";
import {Cascader} from 'element-react';

 

import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';

export default class FsColor extends KeeVue {
    constructor(props) {
        super(props);

        this.state = {

            isShow: false,
            randId: this.getRandString(),
            id: this.getRandString(),
            targetId: '',
            selectIcons: [],
            selectIconClass: '',
            allUsers: [],
            keyWord: '',
            filterUsers: [],
            iconList: [],
            currentRoleId: '',
            orgList: [],
            reqeustTimes: 0, // 请求次数，自增，用来区分服务器返回的数据
            isSelected: false,
        }

    }

    componentDidMount() {
        var that = this;
        if (this.props.component)
            this.state.targetId = this.props.component.id;
        if (this.props.editable === false || (that.props.form && (that.props.form.editable === false || that.props.form.cp.editable === false))) {
        } else {
            { }
        }
         
        this.registComponent();
		
		// this.createColorPick();
		
    }
	
	createColorPick(){
		let that = this;
		setTimeout(()=>{
			let obj = document.getElementById(this.state.randId);
			
			if(obj)
			{
				let a = window.Colorpicker.create({
					el: that.state.randId,
					color: (this.props.component.value?this.props.component.value:''),
					change:  (elem, hex)=> {
						
						console.log("收到颜色"+hex+"this.props.component.cp.field:"+this.props.component.cp.field);
						
						this.props.component.value = hex;
						
						this.setVueAttr(this.props.po, this.props.component.cp.field,hex);
						//this.props.component.value = hex; 
						// if (this.props.po && this.props.po.id) {
						//     this.sendEvent(this.props.po.id + ".render");
						// }
						
						//alert("this.props.component.id:"+this.props.component.id);
				  
						 this.sendPageEvent("change", hex);
						 
						 this.refresh();
						
						//elem.style.backgroundColor = hex;
						
						//this.props.component.value=hex;
						//document.getElementById("picker_input").value = hex;
					}
				})
			}
			else
			{
				setTimeout(()=>{this.createColorPick();},1000);
			}
			
			
		},150)
	}

   
    render() { 
		
		this.createColorPick()

          return   <div id={this.state.randId} style={{display:'inline-block' }}> 
				<div style={{display:'inline-block',width:'80px'}}>
				<Input  defaultValue={this.props.component.value} value={this.props.component.value}
				  
				 size="middle"
				 type="text" readOnly={true}
				></Input>
				</div>
               
                
               	<div style={{display:'inline-block',marginLeft:'5px'}}  >
				<Button type="primary" >选择颜色</Button>
				</div>
               
            </div>
        
    }
}
